import CryptoJS from 'crypto-js';

//获取上个月的年月
export const getYearAndMonth = () => {
    var date = new Date;
    var year = date.getFullYear();
    var month = date.getMonth();
    if (month == 0) {
        year = year - 1;
        month = 12;
    }
    return {
        year,
        month
    }
}

/***
 * 判断会员是否过期
 * @parse {string} vip_expire 根据vip_expire判断会员是否过期以及是否是会员
 * */
export const getExpire = (vip_expire) => {
    let expire;
    if (vip_expire) {
        expire = vip_expire.replace(/-/g, "/");
    }
    return !(expire && new Date(expire).getTime() > new Date().getTime());
};


//数字千分符
export const format = (num) => {
    return (num + '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1，');
}

//获取距档期凌晨的时间差
export const getToWeeNum = (data, today) => {
    let num1 = data * 1000;
    let num2 = today * 1000;
    return 86400000 - (num1 - num2);
}


// 判断某一时间到今天的天数
export const getDistanceSpecifiedDay = (dateTime) => {
    let expire
    if (dateTime) {
        expire = dateTime.replace(/-/g, '/')
    }
    // 指定日期和时间
    var EndTime = new Date(expire)
    // 当前系统时间
    var NowTime = new Date()
    var t = EndTime.getTime() - NowTime.getTime()
    var d = Math.floor(t / 1000 / 60 / 60 / 24)
    var h = Math.floor(t / 1000 / 60 / 60 % 24)
    var m = Math.floor(t / 1000 / 60 % 60)
    var s = Math.floor(t / 1000 % 60)
    var htmlTisu = '';
    var html = '';
    if (d > 0) {
        html += d + '天';
        htmlTisu += d + ' 天 ';
    }
    if (h > 0) {
        html += h + '小时';
        htmlTisu += h + '小时';
    }
    // if(m>0){
    //     html+=m + '分钟';
    // }
    return {
        day: d,
        hour: h,
        time: html ? html : '小于1小时',
        html: htmlTisu ? htmlTisu : '小于1小时'
    };
}
//计算时间函数
export const getsec = (str) => {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
        // 统一成7天
        return 7 * 24 * 60 * 60 * 1000;
        // return str1 * 1000;
    } else if (str2 == "h") {
        return str1 * 60 * 60 * 1000;
    } else if (str2 == "d") {
        return str1 * 24 * 60 * 60 * 1000;
    } else if (str2 == "m") {
        return str1 * 60 * 1000;
    }
}

//设置cookie
export const setCookie = (name, value, time) => {
    var strsec = getsec(time);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ';path=/;domain=.speedtest.cn';
}

//删除cookie
export const delCookie = (name) => {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ';path=/;domain=.speedtest.cn';
    }
}
//获取cookie
export const getCookie = (name) => {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}

//判断是否是IE
export const isIE = () => {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return "IE";
    }
    return false;
}

//判断是否是Edge
export const isEdge = () => {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    return userAgent.indexOf("Edge") > -1;

}

//获取距文档上方距离
export const getAbsTop = (obj) => {
    var top = obj.offsetTop;
    while (obj === obj.offsetParent) {
        top += obj.offsetTop;
    }
    return top;
}

//获取距文档上方距离
export const getAbsLeft = (obj) => {
    var left = obj.offsetLeft;
    while (obj = obj.offsetParent) {
        left += obj.offsetLeft;
    }
    return left;
}

/**
 * 获取ipv6
 * **/
export const getIPV6 = (callback) => {
    try {
        let myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection; //compatibility for firefox and chrome
        var pc = new myPeerConnection({iceServers: []}),
            noop = function () {
            },
            localIPs = {},
            ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
            key;

        function ipIterate(ip) {
            if (!localIPs[ip] && ip.indexOf('.') < 0) callback(ip);
            localIPs[ip] = true;
        }

        pc.createDataChannel('');
        pc.createOffer().then(function (sdp) {
            if (!sdp) {
                return
            }
            sdp.sdp.split('\n').forEach(function (line) {
                if (line.indexOf('candidate') < 0) return;
                line.match(ipRegex).forEach(ipIterate);
            });
            pc.setLocalDescription(sdp, noop, noop);
        });
        pc.onicecandidate = function (ice) {
            if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
            ice.candidate.candidate.match(ipRegex).forEach(ipIterate);
        };
    } catch (e) {
        callback("")
    }
};

//获取ipv4地址
export const getIpv4 = async (callback) => {
    try {
        let recode = {};
        let RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
        // 如果不存在则使用一个iframe绕过
        if (!RTCPeerConnection) {
            let iframe = document.getElementById('iframe');
            let win = iframe.contentWindow;
            RTCPeerConnection = win.RTCPeerConnection || win.mozRTCPeerConnection || win.webkitRTCPeerConnection;
        }

        //创建实例，生成连接
        let pc = new RTCPeerConnection();

        // 匹配字符串中符合ip地址的字段
        function handleCandidate(candidate) {
            let ip_regexp = /([0-9]{1,3}(\.[0-9]{1,3}){3}|([a-f0-9]{1,4}((:[a-f0-9]{1,4}){7}|:+[a-f0-9]{1,4}){6}))/;
            if (!candidate.match(ip_regexp)) {
                return
            }
            let ip_isMatch = candidate.match(ip_regexp)[1];
            if (!recode[ip_isMatch]) {
                callback(ip_isMatch);
                recode[ip_isMatch] = true;
            }
        }

        //监听icecandidate事件
        pc.onicecandidate = (ice) => {
            if (ice.candidate) {
                handleCandidate(ice.candidate.candidate);
            }
        };
        //建立一个伪数据的通道
        pc.createDataChannel('');
        pc.createOffer((res) => {
            pc.setLocalDescription(res);
        }, () => {
        });
        //延迟，让一切都能完成
        setTimeout(() => {
            try {
                let lines = pc.localDescription.sdp.split('\n');
                lines.forEach(item => {
                    if (item.indexOf('a=candidate:') === 0) {
                        handleCandidate(item);
                    }
                })
            } catch (e) {

            }
        }, 1000);
    } catch (e) {
        callback('');
    }
}

/**
 * 生成随机数
 * @param {number} digit 位数
 * */
export const createrRandom = (digit = 6) => {
    let num = '';
    for (var i = 0; i < digit; i++) {
        num += Math.floor(Math.random() * 10);
    }
    return num;
}

/**
 * 生成一定范围的随机数
 * @param {number} n 最小范围
 * @param {number} m 最大范围
 * */
export const createScopeNum = (n, m) => {
    return Math.floor(Math.random() * (m - n + 1) + n);
}

/**
 * 将对象转化为字符串
 * @param {number} digit 位数
 * */
export const toStringJson = (val) => {
    if (typeof val == 'object') {
        let result;
        if (Array.isArray(val)) {
            result = [];
            for (let i in val) {
                result.push(toStringJson(val[i]))
            }
        } else if (val === null) {
            result = null;
        } else if (val.constructor === RegExp) {
            result = val;
        } else {
            result = {};
            for (let i in val) {
                if (typeof val[i] === 'function') {
                    continue;
                } else if (i === 'plugins') {
                    let plugins = {}
                    for (let j in val[i]) {
                        let pObj = {};
                        for (let o in val[i][j]) {
                            if (typeof val[i][j][o] !== 'object') {
                                pObj[o] = val[i][j][o];
                            }
                        }
                        plugins[j] = pObj;
                    }
                    result[i] = plugins;
                } else if (i == 'enabledPlugin') {
                    result[i] = [];
                } else {
                    result[i] = toStringJson(val[i]);
                }
            }
        }
        return result;
    } else {
        return val
    }
}

//ip脱敏
export const desensitizationIP = (ip) => {
    if (ip) {
        let arr = ip.split('.');
        arr.pop();
        arr.push('*');
        let str = '';
        arr.map((val, index) => {
            if (index == 0) {
                str += val
            } else {
                str += '.' + val;
            }
        })
        return str;
    }
}

//获取系统版本
export const getOsVersion = () => {
    var u = navigator.userAgent, version = ''
    if (u.indexOf('Mac OS X') > -1) {
        // ios
        var regStr_saf = /OS [\d._]*/gi
        var verinfo = u.match(regStr_saf)
        version = 'macOS'
    } else if (u.indexOf('Android') > -1 ||
        u.indexOf('Linux') > -1) {
        // android
        version = 'android'
    } else if (u.indexOf('BB10') > -1) {
        // 黑莓bb10系统
        version = 'blackberry' + u.substr(u.indexOf('BB10') + 5, u.indexOf(';', u.indexOf('BB10')) - u.indexOf('BB10') - 5)
    } else if (u.indexOf('IEMobile') > -1) {
        // windows phone
        version = 'winphone' + u.substr(u.indexOf('IEMobile') + 9, u.indexOf(';', u.indexOf('IEMobile')) - u.indexOf('IEMobile') - 9)
    } else {
        var userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('windows nt 5.0') > -1) {
            version = 'Windows 2000'
        } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
            version = 'Windows XP'
        } else if (userAgent.indexOf('windows nt 6.0') > -1) {
            version = 'Windows Vista'
        } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
            version = 'Windows 7'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
            version = 'Windows 8'
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
            version = 'Windows 8.1'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
            version = 'Windows 10'
        } else {
            version = 'Unknown'
        }
    }
    return version
}

//上报数据加密参数
export const encryptJson = (json) => {
    let str = JSON.stringify(json);
    let keyStr = '5ECC5D62140EC099';
    let ivStr = 'E63EA892A702EEAA';
    const key = CryptoJS.enc.Utf8.parse(keyStr);  //十六位十六进制数作为密钥
    const iv = CryptoJS.enc.Utf8.parse(ivStr);   //十六位十六进制数作为密钥偏移量
    let srcs = CryptoJS.enc.Utf8.parse(str);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});
    let appKey = encrypted.toString();
    return appKey;
}

export const encryptUsid = (str) => {
    let keyStr = 'C28D4DF975B027B6';
    let ivStr = '52BD53B7B05C4236';
    const key = CryptoJS.enc.Utf8.parse(keyStr);  //十六位十六进制数作为密钥
    const iv = CryptoJS.enc.Utf8.parse(ivStr);   //十六位十六进制数作为密钥偏移量
    let srcs = CryptoJS.enc.Utf8.parse(str);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});
    let appKey = encrypted.toString();
    return appKey;
}

/**
 * 对data进行aes解密
 * */
export const aesDeciphering = (data) => {
    let key = "5ECC5D62140EC099";
    let iv = "E63EA892A702EEAA";
    const keyUTF8 = CryptoJS.enc.Utf8.parse(key);
    const offsetUTF8 = CryptoJS.enc.Utf8.parse(iv);
    const bytes = CryptoJS.AES.decrypt(data, keyUTF8, {
        iv: offsetUTF8,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    try {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        return bytes.toString(CryptoJS.enc.Utf8);
    }
}

/**
 * 对数字进行处理（0的话为0，整数位为.00）
 * */
export const decimalNumber = (reqNum) => {
    if (isNaN(+reqNum)) {
        return reqNum;
    }
    if (+reqNum === 0) {
        return 0;
    }
    return Number.parseFloat(reqNum).toFixed(2);
};


/**
 * 设置缓存
 * @param key 键
 * @param value 值
 * @param expire 过期时间(秒) 缓存最大时间请勿超过 forceTime 否则每次都会清空数据 (未设置请忽略)
 * @return bool true
 */
export const cacheSet = (key, value = '', expire = 0) => {
    // 当前时间戳
    let nowTime = Math.ceil(Date.now() / 1000);
    // 设置数据
    localStorage.setItem(key, JSON.stringify(value))
    // 设置过期时间
    localStorage.setItem(key + '_expire', expire > 0 ? (nowTime + parseInt(expire)) : 0)
    return true;
}


/**
 * 读取缓存
 */
export const cacheGet = (key) => {
    // 当前时间戳
    let nowTime = Math.ceil(Date.now() / 1000);
    // 获取键时间戳
    let rawCacheDataExpire = localStorage.getItem(key + '_expire');
    let cacheDataExpire = parseInt(rawCacheDataExpire);
    // 判断用户是否删除了过期时间 判断是否设置了过期时间 判断是否超过过期时间 判断当前计算机时间与设置的过期时间差距是否过大
    if ((rawCacheDataExpire === null) || (cacheDataExpire > 0 && (nowTime > cacheDataExpire))) {
        // 删除过期key
        localStorage.removeItem(key)
        // 删除过期时间
        localStorage.removeItem(key + '_expire')
        return false;
    }

    // 获取数据
    let cacheData = JSON.parse(localStorage.getItem(key));

    if (cacheData === null || cacheData === false) {
        return false;
    }
    // 返回数据
    return cacheData;
}


/**
 * 根据运营商获取图标
 * */
export const handleIspIcon = (reqIsp) => {
    let ispIconMap = new Map([
        [0, require('../images/speedtest-result/dx-icon.svg')],
        [1, require('../images/speedtest-result/lt-icon.svg')],
        [2, require('../images/speedtest-result/yd-icon.svg')],
        [3, require('../images/speedtest-result/other-icon.svg')]
    ])
    let ispNameList = ['电信', '联通', '移动'];
    if (reqIsp.includes(ispNameList[0])) {
        return ispIconMap.get(0);
    }
    if (reqIsp.includes(ispNameList[1])) {
        return ispIconMap.get(1);
    }
    if (reqIsp.includes(ispNameList[2])) {
        return ispIconMap.get(2);
    }
    return ispIconMap.get(3);
}

/**
 * 根据网络类型获取名称
 * */
export const queryNetworkName = (reqNetwork) => {
    let networkMap = new Map([
        [1, '宽带'],
        [2, 'Wi-Fi'],
        [3, '2G'],
        [4, '3G'],
        [5, '4G'],
        [6, '5G']
    ])
    try {
        return networkMap.get(+reqNetwork)
    } catch (e) {
        return '其他'
    }
}


/**
 * 获取url参数
 * @param {string} variable
 * */
export const getQueryVariable = (variable) => {
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
}


//判断是否ioswebview打开
export const openInWebview = () => {
    let ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('iosapp') > -1;
}

/**获取id方法
 *str 传入需要解析id的字符串
 */
export const getStrToUrl = (str, target) => {
    if (!str) {
        return ""
    }
    let result = '';
    if (str.indexOf(target + '=') === -1) {
        return '';
    } else {
        for (let i = str.indexOf(target + '=') + target.length + 1; i < str.length; i++) {
            if (str[i] !== '&') {
                result += str[i]
            } else {
                break;
            }
        }
        return result;
    }
}

/**
 * 获取当前的系统
 * @return {number} 0:win32; 1:win64; 2 macOS
 * */
export const queryOs = () => {
    let agent = navigator.userAgent.toLowerCase();
    let osType = 0
    if (agent.indexOf("win64") >= 0 || agent.indexOf("x64") >= 0 || agent.indexOf("wow64") >= 0) {
        osType = 1;
    }
    if(agent.indexOf('mac')){
        osType = 2
    }
    return osType;
}


// 手机号脱敏
export const noPassByPhone = (phone) => {
    phone += ''
    return (phone + '').substring(0, 3) + "****" + phone.substring(7);
}

//判断是否为mac
export const isMacFn = (phone) => {
    let agent = navigator.userAgent.toLowerCase();
    let isMac = /macintosh|mac os x/i.test(agent);
    return isMac
}

//登录失败提示
export const logoffToast = (slef) => {
    let urlSearch = location.search
    urlSearch.replace(/logoffMsg=([^&]+)/, ($0, $1, $2) => {
        slef.$message.error(decodeURIComponent($1));
        history.pushState({}, '', location.href.replace(/&?logoffMsg=[^&]*/g, ''))
    })
}

// 节流
export const throttle = function (fn, delay) {
    let timer = null;
    return function () {
        let content = this;
        let args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn.apply(content, args);
        }, delay);
    };
}

export const nowDateFn=()=>{
    let date = new Date()
    let nowTime = `${date.getFullYear()}${(date.getMonth() + 1 + '').padStart(2, '0')}${(date.getDate() + '').padStart(2, '0')}`
    return nowTime
}



// WEBPACK FOOTER //
// ./resources/js/globalFunction.js